/* Connoisseur offer page: send the chosen box to checkout.
   Same pattern as the taste profile funnel (assets/quiz-questions.js): clear the cart, add the box
   with its selling plan plus the first-order gifts from the backend tier config, then go to /checkout.
   Every line carries _bundleId and _role, gifts _role "gift" (that is what makes them free at
   checkout); subscription lines and the cart also carry the 3-month milestone markers. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var root = document.querySelector('.wlb-buy-root');
    var btn = root && root.querySelector('[data-wlb-checkout]');
    var dataEl = document.getElementById('ConnoisseurOfferData');
    if (!root || !btn || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // Which selling plan is every 1, 2 and 3 months: read from the plan's own name and options.
    function monthsOf(plan) {
      var text = [plan.name, plan.group].concat(plan.options || []).join(' ').toLowerCase();
      var m = text.match(/(?:every\s+)?(\d+)\s*-?\s*month/);
      if (m) return parseInt(m[1], 10);
      if (/monthly|every month|each month|1 month/.test(text)) return 1;
      return null;
    }
    var planByMonths = {};
    (data.plans || []).forEach(function (p) {
      if (/prepaid|prepay/i.test(p.name + ' ' + p.group)) return;   // the prepaid plan is an upsell, never sold here
      var n = monthsOf(p); if (n && !planByMonths[n]) planByMonths[n] = p.id;
    });

    // Do not offer a pace or a choice the store cannot check out.
    var freq = root.querySelector('[data-wlb-freq]');
    if (freq) {
      Array.prototype.slice.call(freq.options).forEach(function (o) {
        if (!planByMonths[parseInt(o.value, 10)]) o.remove();
      });
      if (freq.options.length) { freq.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var onetime = root.querySelector('.wlb-option[data-option="onetime"]');
    if (onetime && data.requiresSellingPlan) { onetime.hidden = true; onetime.style.display = 'none'; }
    root.setAttribute('data-wlb-plans', JSON.stringify(planByMonths));

    // First-order gifts come from the backend's own tier config, the same source the taste profile
    // funnel uses (GET {apiBase}/api/tiers?tiers=3_month_connoisseur, items with _role "gift").
    // The theme setting tp_connoisseur_gifts is NOT used: it still lists a $25 digital gift card.
    // If the backend cannot be reached, fall back to the two gifts it listed on 2026-10-12:
    // 44348665331907 is the two tasting glasses, 54048502481091 the digital whiskey guide (PDF).
    var FALLBACK_GIFTS = [44348665331907, 54048502481091];
    var giftItems = null;
    try {
      fetch(String(data.apiBase).replace(/\/$/, '') + '/api/tiers?tiers=' + encodeURIComponent(data.tierKey), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var t = j && j.data && j.data.tiers && j.data.tiers[data.tierKey];
          if (!t || !Array.isArray(t.items)) return;
          giftItems = t.items.filter(function (it) { return it && it._role === 'gift' && it.variant; });
          root.setAttribute('data-wlb-gifts', JSON.stringify(giftItems.map(function (it) { return Number(it.variant); })));
        }).catch(function () {});
    } catch (e) {}
    function gifts() {
      var list = giftItems || FALLBACK_GIFTS.map(function (id) { return { variant: id }; });
      return list.map(function (it) {
        var line = { id: Number(it.variant), quantity: 1, _role: 'gift' };
        if (it.flatDiscount != null && it.flatDiscount !== '') line.flatDiscount = it.flatDiscount;
        return line;
      });
    }

    // The checkout discount (wl-apps discount-engine) makes a line free only when its _role
    // property is "gift", and the 3-month milestone (months 2 and 3) is keyed on
    // _milestoneProgram / _milestoneTier. Same properties as the BOF page and the taste profile.
    var MILESTONE_PROGRAM = '3-month-milestone';
    function tagLines(items, bundleId, subscription) {
      return items.map(function (item) {
        var role = item._role || 'main';
        var props = { _bundleId: bundleId, _role: role };
        if (subscription) { props._milestoneProgram = MILESTONE_PROGRAM; props._milestoneTier = data.tierKey; }
        if (role === 'gift' && item.flatDiscount != null && item.flatDiscount !== '') props._flatDiscount = String(item.flatDiscount).trim();
        var line = { id: item.id, quantity: item.quantity, properties: props };
        if (item.selling_plan) line.selling_plan = item.selling_plan;
        return line;
      });
    }
    // wlReportToken: the reporter's fetch wrapper (cart-failure-reporter.js) holds its own report of a
    // failed cart call for 1.5 s and drops it when this page reports the same token with more context.
    // Tokens are objects: the reporter keeps them in a WeakSet (a string token makes report() throw).
    function post(url, body, token) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', wlReportToken: token,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined })
        .then(function (r) {
          if (r.ok) return r;
          var err = new Error(url + ' ' + r.status);
          err.http_status = r.status; err.cart_endpoint = url;
          throw err;
        });
    }
    function report(stage, err, token, extra) {
      var R = window.WhiskyCartFailure;
      if (!R || typeof R.report !== 'function') return;
      R.report(Object.assign({
        source: 'connoisseur_offer_page',
        stage: stage,
        error_message: (err && err.message) || String(err),
        http_status: err && err.http_status,
        cart_endpoint: err && err.cart_endpoint,
        _reportToken: token,
        tier_key: data.tierKey,
        funnel_mode: 'redirect_checkout'
      }, extra || {}));
    }

    // Analytics: the same queue + bubbling event pattern as the BOF and Brewzle pages;
    // assets/analytics-posthog-funnel.js turns them into connoisseur_offer_* events.
    function announce(state, detail) {
      var payload = Object.assign({ tier_key: data.tierKey }, detail || {});
      try {
        (window.__coOfferQueue = window.__coOfferQueue || []).push({ state: state, detail: payload });
        root.dispatchEvent(new CustomEvent('co-offer:' + state, { bubbles: true, detail: payload }));
      } catch (e) {}
    }

    // A failed tap says so on the button, as the BOF page does, and stays on the page.
    // The visible label stays plain text so it names the button; a separate hidden status
    // region outside the button is what screen readers announce.
    var RETRY_LABEL = 'Could not add, tap to try again';
    var btnText = btn.querySelector('.tp-cta__btn-text');
    var btnError = null, btnStatus = null;
    function showRetry() {
      if (!btnText) return;
      if (!btnError) {
        btnError = document.createElement('span');
        btnError.className = 'tp-cta__btn-text';
        btn.appendChild(btnError);
        btnStatus = document.createElement('span');
        btnStatus.setAttribute('role', 'status');
        btnStatus.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
        btn.parentNode.insertBefore(btnStatus, btn.nextSibling);
      }
      btnError.textContent = RETRY_LABEL;
      btnError.style.display = '';
      btnText.style.display = 'none';
      btnStatus.textContent = '';
      setTimeout(function () { if (btnStatus) btnStatus.textContent = RETRY_LABEL; }, 50);
    }
    function clearRetry() {
      if (!btnError) return;
      btnError.style.display = 'none';
      btnText.style.display = '';
      btnStatus.textContent = '';
    }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    var busy = false;
    function reset() { busy = false; btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
    // Back from checkout can restore this page from the back-forward cache with busy still set.
    window.addEventListener('pageshow', function (e) { if (e.persisted) { reset(); clearRetry(); } });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      clearRetry();
      var plan = btn.getAttribute('data-plan');           // "1", "2", "3" or "onetime"
      var box = { id: Number(data.variantId), quantity: 1 };
      if (plan !== 'onetime') {
        var planId = planByMonths[parseInt(plan, 10)];
        if (!planId) return;                              // no such plan on the store: do nothing
        box.selling_plan = Number(planId);
      } else if (data.requiresSellingPlan) { return; }
      busy = true; btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7';
      var subscription = plan !== 'onetime';
      var price = btn.querySelector('[data-wlb-btn-price]');
      var clicked = { plan: plan, selling_plan: box.selling_plan ? String(box.selling_plan) : null, price: price ? price.textContent.trim() : null };
      announce('buy_clicked', clicked);
      var bundleId = data.tierKey + '_' + Date.now();
      var withGifts = tagLines([box].concat(gifts()), bundleId, subscription);
      // Order attributes: Recharge copies these onto renewals (line properties do not reach
      // them), and an empty string clears a value an earlier offer page left on the cart.
      var attributes = {
        _milestoneProgram: subscription ? MILESTONE_PROGRAM : '',
        _milestoneTier: subscription ? data.tierKey : '',
        _offerProgram: '',
        _starterTierTest: ''
      };
      var tokens = { clear: {}, gifts: {}, box: {}, attrs: {} };   // one per step; both tries of a step share it
      // The clear has to land: adding on top of an earlier box would check out two (one retry,
      // Shopify answers a burst with 429). If it never lands, stop and report.
      post('/cart/clear.js', null, tokens.clear)
        .catch(function () { return new Promise(function (r) { setTimeout(r, 800); }).then(function () { return post('/cart/clear.js', null, tokens.clear); }); })
        .catch(function (err) { report('cart_clear', err, tokens.clear); announce('add_failed', Object.assign({ stage: 'cart_clear' }, clicked)); throw err; })
        .then(function () {
          return post('/cart/add.js', { items: withGifts }, tokens.gifts).catch(function (err) {
            // Gifts refused (sold out, a 429): the box alone still checks out, and the missing
            // gifts are reported so support can send them. Read the cart first: when the add
            // landed and only its answer was lost, a second add would check out two boxes.
            return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
              .then(function (r) { if (!r.ok) throw err; return r.json(); })
              .then(function (cart) {
                var lines = (cart && cart.items) || [];
                var hasBox = lines.some(function (l) { return Number(l.variant_id) === box.id; });
                if (hasBox) {
                  if (lines.length < withGifts.length) report('gift_add', err, tokens.gifts, { gifts_dropped: true, box_in_cart: true });
                  return;
                }
                report('gift_add', err, tokens.gifts, { gifts_dropped: true });
                return post('/cart/add.js', { items: tagLines([box], bundleId, subscription) }, tokens.box)
                  .catch(function (err2) { report('cart_add', err2, tokens.box); announce('add_failed', Object.assign({ stage: 'cart_add' }, clicked)); throw err2; });
              }, function (readErr) {
                report('gift_add', readErr, tokens.gifts, { cart_read_failed: true });
                announce('add_failed', Object.assign({ stage: 'cart_read' }, clicked));
                throw readErr;
              });
          });
        })
        .then(function () {
          // After the add, never beside it: a write sent with the add can land on another cart.
          // Without the markers a subscriber misses the month 2 and 3 rewards, so one retry,
          // then stop here with the error on the button instead of going to checkout.
          function writeAttributes() {
            return post('/cart/update.js', { attributes: attributes }, tokens.attrs)
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var stored = cart && cart.attributes ? cart.attributes._milestoneProgram : undefined;
                if (subscription ? stored !== MILESTONE_PROGRAM : !!stored) {
                  var err = new Error('/cart/update.js did not store _milestoneProgram');
                  err.cart_endpoint = '/cart/update.js';
                  throw err;
                }
              });
          }
          return writeAttributes()
            .catch(function () { return wait(800).then(writeAttributes); })
            .catch(function (err) {
              report('cart_attributes', err, tokens.attrs);
              announce('attributes_failed', clicked);
              throw err;
            });
        })
        .then(function () {
          announce('checkout_started', clicked);
          window.location.assign('/checkout');
        })
        .catch(function () { reset(); showRetry(); });
    });
  });
})();
